/* @flow */
import * as React from 'react';
import MediaObject from 'components/MediaObject.jsx';
import Text from 'components/Text.jsx';
import ComposableTableHeaderInfoIcon from './ComposableTableHeaderInfoIcon.jsx';
import type { ColumnHeader } from './ComposableTable.jsx';

type Props = {
  columnHeader: ColumnHeader,
};

export default function ComposableTableHeader(props: Props) {
  const { columnHeader } = props;

  return (
    <MediaObject center figure="right" gutter="xxsmall" inline>
      <Text data-test="column-header">{columnHeader.name}</Text>
      <ComposableTableHeaderInfoIcon columnHeader={columnHeader} />
    </MediaObject>
  );
}
